import { Language } from '@ngx-translate/core';

/**
 * Language part of a UI locale, e.g. 'de' for 'de-CH'.
 * Use this where external systems only know the language (Keycloak, ZSR register, support widget).
 */
export function toLanguageCode(language: Language): string {
  return language.split('-')[0];
}
